import { TestCaseGroup } from "@/common/api.service"
import { FETCH_TEST_GROUP, FETCH_INDIVIDUAL_TEST_GROUP, ADD_TEST_GROUP, UPDATE_TEST_GROUP,RESET_STATE, DELETE_TEST_GROUP } from "./actions.type"
import { SET_TEST_GROUP, SET_INDIVIDUAL_TEST_GROUP, SET_ERROR_TEST_GROUP,STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
        testgroup: [],
        individualtestgroup: [],
        testgrouperrors: null,
    }
}

let state = initialState()

const getters = {
    testgroup(state) {
        return state.testgroup
    },
    individualtestgroup(state) {
        return state.individualtestgroup
    }
}

const actions = {
    async [FETCH_TEST_GROUP](context, slug) {
        const { data } = await TestCaseGroup.get(slug)
        context.commit(SET_TEST_GROUP, data.data)
        return data;
    },
    async [FETCH_INDIVIDUAL_TEST_GROUP](context, slug) {
        const { data } = await TestCaseGroup.get(slug)
        context.commit(SET_INDIVIDUAL_TEST_GROUP, data.data)
        return data;
    },  
    async [ADD_TEST_GROUP](context, payload) {
        return await TestCaseGroup.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEST_GROUP, error.response.data.errors)
        });
    },     
    async [UPDATE_TEST_GROUP](context, payload) {
        return await TestCaseGroup.update(payload, payload.tc_group_id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEST_GROUP, error.response.data.errors)
        });
    },  
    async [DELETE_TEST_GROUP] (context, id) {
        return await TestCaseGroup.delete(id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEST_GROUP, error.response.data.errors)
        });
    },    
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_ERROR_TEST_GROUP](state, error) {
        state.testgrouperrors = error
    },      
    [SET_TEST_GROUP](state, testgroupdata) {
        state.testgroup = testgroupdata
    },
    [SET_INDIVIDUAL_TEST_GROUP](state, individualtestgroup) {
        state.individualtestgroup = individualtestgroup
    },    
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};